import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { map, switchMap, tap } from 'rxjs/operators';
import {
  DoctorActionTypes,
  GetPatientsSuccess,
  GetPatientsFailure,
  GetQuestionnairesEORTC,
  GetQuestionnairesEORTCSuccess,
  GetQuestionnairesEORTCFailure,
  GetQuestionnairesEQ5D5L,
  GetQuestionnairesEQ5D5LFailure,
  GetQuestionnairesEQ5D5LSuccess,
  GetQuestionnairesHBI,
  GetQuestionnairesHBISuccess,
  GetQuestionnairesHBIFailure,
  GetQuestionnairesIBDDisk,
  GetQuestionnairesIBDDiskSuccess,
  GetQuestionnairesIBDDiskFailure,
  GetQuestionnairesSIBDQ,
  GetQuestionnairesSIBDQSuccess,
  GetQuestionnairesSIBDQFailure,
  GetQuestionnairesTSQMSuccess,
  GetQuestionnairesTSQMFailure,
  GetQuestionnairesWPAI,
  GetQuestionnairesWPAISuccess,
  GetQuestionnairesWPAIFailure,
  GetQuestionnairesTSQM,
  GetJobs,
  GetJobsSuccess,
  GetQuestionnairesClinicalSCCAI,
  GetQuestionnairesClinicalSCCAISuccess,
  GetQuestionnairesClinicalSCCAIFailure,
  GetQuestionnairesHADS,
  GetQuestionnairesHADSSuccess,
  GetQuestionnairesIPAQSF,
  GetQuestionnairesIPAQSFSuccess,
  GetQuestionnairesMIAHCDSuccess,
  GetQuestionnairesMIAHCDFailure,
  GetQuestionnairesMIAHUC,
  GetQuestionnairesMIAHUCFailure,
  GetQuestionnairesMMAS8Success,
  GetQuestionnairesMMAS8Failure,
  GetQuestionnairesPatientSCCAISuccess,
  GetQuestionnairesPatientSCCAIFailure,
  GetQuestionnairesPHQ9,
  GetQuestionnairesPHQ9Success,
  GetQuestionnairesPHQ9Failure,
  GetQuestionnairesPSQI,
  GetQuestionnairesPSQISuccess,
  GetQuestionnairesIPAQSFFailure,
  GetQuestionnairesPSQIFailure,
  GetQuestionnairesMIAHCD,
  GetQuestionnairesMIAHUCSuccess,
  GetQuestionnairesPRISM,
  GetQuestionnairesPRISMFailure,
  GetQuestionnairesPRISMSuccess,
  GetQuestionnairesClinicalHBI,
  GetQuestionnairesClinicalHBISuccess,
  GetQuestionnairesClinicalHBIFailure,
  GetQuestionnairesClinicalPRISM,
  GetQuestionnairesClinicalPRISMSuccess, GetQuestionnairesClinicalPRISMFailure, GetGlobalPatientsFailure, GetGlobalPatientsSuccess,
  GetQuestionnairesIBDQ,
  GetQuestionnairesIBDQSuccess,
  GetQuestionnairesIBDQFailure,
  GetQuestionnairesLARS,
  GetQuestionnairesLARSSuccess,
  GetQuestionnairesLARSFailure,
  GetQuestionnairesDataConsent,
  GetQuestionnairesDataConsentSuccess,
  GetQuestionnairesDataConsentFailure,
} from '../actions/doctor.actions';
import { DoctorService } from '../../services/doctor.service';
import {
  QuestionnaireClinicalHBIResult,
  QuestionnaireClinicalPRISMResult,
  QuestionnaireClinicalSCCAIResult,
  QuestionnaireEORTCResult,
  QuestionnaireEQ5D5LResult,
  QuestionnaireHADSResult,
  QuestionnaireHBIResult,
  QuestionnaireIBDDiskResult,
  QuestionnaireIPAQSFResult,
  QuestionnaireMIAHCDResult,
  QuestionnaireMIAHUCResult,
  QuestionnaireMMAS8Result,
  QuestionnairePatientSCCAIResult, QuestionnairePHQ9Result, QuestionnairePRISMResult, QuestionnairePSQIResult,
  QuestionnaireSIBDQResult,
  QuestionnaireTSQMResult,
  QuestionnaireWPAIResult,
  QuestionnaireIBDQResult,
  QuestionnaireLARSResult,
  QuestionnaireDataConsentResult,
} from '../../model/questionnaires/questionnaire-results';
import { Patient } from '../../model/user/Patient';
import { JobModel } from '../../model/job/JobModel';

@Injectable()
export class DoctorEffects {

  constructor(
    private actions$: Actions,
    private doctorService: DoctorService) { }

  // effects go here

  @Effect()
  GetPatients: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_PATIENTS),
    // tap( () => console.log(DoctorActionTypes.GET_PATIENTS + ' Effect - get patients-control-panel')),
    switchMap(() => {
      return this.doctorService.getPatients()
        .map((patientArray) => {
          return new GetPatientsSuccess({
            patients: patientArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetPatientsFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetPatientsSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_PATIENTS_SUCCESS),
    tap((data) => {
      localStorage.setItem('patients', JSON.stringify(data.payload.patients));
    })
  );

  @Effect({ dispatch: false })
  GetPatientsFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_PATIENTS_FAILURE),
    tap((data) => {
      const empty: Patient[] = [];
      localStorage.setItem('patients', JSON.stringify(empty));
    })
  );

  @Effect()
  GetGlobalPatients: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_GLOBAL_PATIENTS),
    // tap( () => console.log(DoctorActionTypes.GET_GLOBAL_PATIENTS + ' Effect - get patients-control-panel')),
    switchMap(() => {
      return this.doctorService.getGlobalPatients()
        .map((patientArray) => {
          return new GetGlobalPatientsSuccess({
            patients: patientArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetGlobalPatientsFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetGlobalPatientsSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_GLOBAL_PATIENTS_SUCCESS),
    tap((data) => {
      localStorage.setItem('patients', JSON.stringify(data.payload.patients));
    })
  );

  @Effect({ dispatch: false })
  GetGlobalPatientsFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_GLOBAL_PATIENTS_FAILURE),
    tap((data) => {
      const empty: Patient[] = [];
      localStorage.setItem('patients', JSON.stringify(empty));
    })
  );

  // TODO: add new effect after a new questionnaire type added

  @Effect()
  GetQuestionnairesClinicalSCCAI: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_C_SCCAI),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_C_SCCAI + ' Effect - get questionnaires for patient')),
    map((action: GetQuestionnairesClinicalSCCAI) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesClinicalSCCAI(payload, 'CLINICAL-SCCAI')
        .map((sccaiArray: QuestionnaireClinicalSCCAIResult[]) => {
          return new GetQuestionnairesClinicalSCCAISuccess({
            resultsClinicalSCCAI: sccaiArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesClinicalSCCAIFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesClinicalSCCAISuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_C_SCCAI_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('clinical-sccai') !== null) {
        localStorage.removeItem('clinical-sccai');
      }
      localStorage.setItem('clinical-sccai', JSON.stringify(data.payload.resultsClinicalSCCAI));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesClinicalSCCAIFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_C_SCCAI_FAILURE)
  );

  @Effect()
  GetQuestionnairesClinicalHBI: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_C_HBI),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_C_HBI + ' Effect - get questionnaires for patient')),
    map((action: GetQuestionnairesClinicalHBI) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesClinicalHBI(payload, 'CLINICAL-HBI')
        .map((hbiArray: QuestionnaireClinicalHBIResult[]) => {
          return new GetQuestionnairesClinicalHBISuccess({
            resultsClinicalHBI: hbiArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesClinicalHBIFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesClinicalHBISuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_C_HBI_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('clinical-hbi') !== null) {
        localStorage.removeItem('clinical-hbi');
      }
      localStorage.setItem('clinical-hbi', JSON.stringify(data.payload.resultsClinicalHBI));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesClinicalHBIFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_C_HBI_FAILURE)
  );

  @Effect()
  GetQuestionnairesClinicalPRISM: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_C_PRISM),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_C_PRISM + ' Effect - get questionnaires for patient')),
    map((action: GetQuestionnairesClinicalPRISM) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesClinicalPRISM(payload, 'CLINICAL-PRISM')
        .map((prismArray: QuestionnaireClinicalPRISMResult[]) => {
          return new GetQuestionnairesClinicalPRISMSuccess({
            resultsClinicalPRISM: prismArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesClinicalPRISMFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesClinicalPRISMSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_C_PRISM_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('clinical-prism') !== null) {
        localStorage.removeItem('clinical-prism');
      }
      localStorage.setItem('clinical-prism', JSON.stringify(data.payload.resultsClinicalPRISM));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesClinicalPRISMFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_C_PRISM_FAILURE)
  );

  @Effect()
  GetQuestionnairesEORTC: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_EORTC),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_EORTC + ' Effect - get questionnaires EORTC for patient')),
    map((action: GetQuestionnairesEORTC) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesEORTC(payload, 'EORTC-QLQ')
        .map((eortcArray: QuestionnaireEORTCResult[]) => {
          return new GetQuestionnairesEORTCSuccess({
            resultsEORTC: eortcArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesEORTCFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesEORTCSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_EORTC_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('eortc-qlq') !== null) {
        localStorage.removeItem('eortc-qlq');
      }
      localStorage.setItem('eortc-qlq', JSON.stringify(data.payload.resultsEORTC));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesEORTCFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_EORTC_FAILURE)
  );

  @Effect()
  GetQuestionnairesEQ5D5L: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_EQ5D5L),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_EQ5D5L + ' Effect - get questionnaires EQ5D5L for patient')),
    map((action: GetQuestionnairesEQ5D5L) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesEQ5D5L(payload, 'EQ5D5L')
        .map((eq5d5lArray: QuestionnaireEQ5D5LResult[]) => {
          return new GetQuestionnairesEQ5D5LSuccess({
            resultsEQ5D5L: eq5d5lArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesEQ5D5LFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesEQ5D5LSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_EQ5D5L_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('eq5d5l') !== null) {
        localStorage.removeItem('eq5d5l');
      }
      localStorage.setItem('eq5d5l', JSON.stringify(data.payload.resultsEQ5D5L));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesEQ5D5LFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_EQ5D5L_FAILURE)
  );

  @Effect()
  GetQuestionnairesHADS: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_HADS),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_HADS + ' Effect - get questionnaires for patient')),
    map((action: GetQuestionnairesHADS) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesHADS(payload, 'HADS')
        .map((hadsArray: QuestionnaireHADSResult[]) => {
          return new GetQuestionnairesHADSSuccess({
            resultsHADS: hadsArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesEORTCFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesHADSSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_HADS_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('hads') !== null) {
        localStorage.removeItem('hads');
      }
      localStorage.setItem('hads', JSON.stringify(data.payload.resultsHADS));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesHADSFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_HADS_FAILURE)
  );

  @Effect()
  GetQuestionnairesHBI: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_HBI),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_HBI + ' Effect - get questionnaires HBI for patient')),
    map((action: GetQuestionnairesHBI) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesHBI(payload, 'HBI')
        .map((hbiArray: QuestionnaireHBIResult[]) => {
          return new GetQuestionnairesHBISuccess({
            resultsHBI: hbiArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesHBIFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesHBISuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_HBI_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('hbi') !== null) {
        localStorage.removeItem('hbi');
      }
      localStorage.setItem('hbi', JSON.stringify(data.payload.resultsHBI));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesHBIFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_HBI_FAILURE)
  );

  @Effect()
  GetQuestionnairesIBDDisk: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_IBDDISK),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_IBDDISK + ' Effect - get questionnaires IBDDisk for patient')),
    map((action: GetQuestionnairesIBDDisk) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesIBDDisk(payload, 'IBD-DISK')
        .map((ibdDiskArray: QuestionnaireIBDDiskResult[]) => {
          return new GetQuestionnairesIBDDiskSuccess({
            resultsIBDDisk: ibdDiskArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesIBDDiskFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesIBDDiskSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_IBDDISK_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('ibd-disk') !== null) {
        localStorage.removeItem('ibd-disk');
      }
      localStorage.setItem('ibd-disk', JSON.stringify(data.payload.resultsIBDDisk));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesIBDDiskFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_IBDDISK_FAILURE)
  );

  @Effect()
  GetQuestionnairesIPAQSF: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_IPAQSF),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_IPAQSF + ' Effect - get questionnaires for patient')),
    map((action: GetQuestionnairesIPAQSF) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesIPAQSF(payload, 'IPAQ-SF')
        .map((ipaqSfArray: QuestionnaireIPAQSFResult[]) => {
          return new GetQuestionnairesIPAQSFSuccess({
            resultsIPAQSF: ipaqSfArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesIPAQSFFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesIPAQSFSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_IPAQSF_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('ipaq-sf') !== null) {
        localStorage.removeItem('ipaq-sf');
      }
      localStorage.setItem('ipaq-sf', JSON.stringify(data.payload.resultsIPAQSF));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesIPAQSFFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_IPAQSF_FAILURE)
  );

  @Effect()
  GetQuestionnairesMIAHCD: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_CD),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_CD + ' Effect - get questionnaires for patient')),
    map((action: GetQuestionnairesMIAHCD) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesMIAHCD(payload, 'MIAH-CD')
        .map((miahcdArray: QuestionnaireMIAHCDResult[]) => {
          return new GetQuestionnairesMIAHCDSuccess({
            resultsMIAHCD: miahcdArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesMIAHCDFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesMIAHCDSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_CD_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('miah-cd') !== null) {
        localStorage.removeItem('miah-cd');
      }
      localStorage.setItem('miah-cd', JSON.stringify(data.payload.resultsMIAHCD));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesMIAHCDFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_CD_FAILURE)
  );

  @Effect()
  GetQuestionnairesMIAHUC: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_UC),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_UC + ' Effect - get questionnaires for patient')),
    map((action: GetQuestionnairesMIAHUC) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesMIAHUC(payload, 'MIAH-UC')
        .map((miahucArray: QuestionnaireMIAHUCResult[]) => {
          return new GetQuestionnairesMIAHUCSuccess({
            resultsMIAHUC: miahucArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesMIAHUCFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesMIAHUCSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_UC_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('miah-uc') !== null) {
        localStorage.removeItem('miah-uc');
      }
      localStorage.setItem('miah-uc', JSON.stringify(data.payload.resultsMIAHUC));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesMIAHUCFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_UC_FAILURE)
  );

  @Effect()
  GetQuestionnairesMMAS8: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_MMAS8),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_MMAS8 + ' Effect - get questionnaires for patient')),
    map((action: GetQuestionnairesMIAHUC) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesMMAS8(payload, 'MMAS8')
        .map((mmas8Array: QuestionnaireMMAS8Result[]) => {
          return new GetQuestionnairesMMAS8Success({
            resultsMMAS8: mmas8Array
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesMMAS8Failure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesMMAS8Success: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_MMAS8_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('mmas8') !== null) {
        localStorage.removeItem('mmas8');
      }
      localStorage.setItem('mmas8', JSON.stringify(data.payload.resultsMMAS8));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesMMAS8Failure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_MMAS8_FAILURE)
  );

  @Effect()
  GetQuestionnairesPatientSCCAI: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_P_SCCAI),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_P_SCCAI + ' Effect - get questionnaires for patient')),
    map((action: GetQuestionnairesMIAHUC) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesPatientSCCAI(payload, 'PATIENT-SCCAI')
        .map((patientSCCAIArray: QuestionnairePatientSCCAIResult[]) => {
          return new GetQuestionnairesPatientSCCAISuccess({
            resultsPatientSCCAI: patientSCCAIArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesPatientSCCAIFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesPatientSCCAISuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_P_SCCAI_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('patient-sccai') !== null) {
        localStorage.removeItem('patient-sccai');
      }
      localStorage.setItem('patient-sccai', JSON.stringify(data.payload.resultsPatientSCCAI));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesPatientSCCAIFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_P_SCCAI_FAILURE)
  );

  @Effect()
  GetQuestionnairesPHQ9: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_PHQ9),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_PHQ9 + ' Effect - get questionnaires for patient')),
    map((action: GetQuestionnairesPHQ9) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesPHQ9(payload, 'PHQ9')
        .map((phq9Array: QuestionnairePHQ9Result[]) => {
          return new GetQuestionnairesPHQ9Success({
            resultsPHQ9: phq9Array
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesPHQ9Failure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesPHQ9Success: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_PHQ9_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('phq9') !== null) {
        localStorage.removeItem('phq9');
      }
      localStorage.setItem('phq9', JSON.stringify(data.payload.resultsPHQ9));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesPHQ9Failure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_PHQ9_FAILURE)
  );

  @Effect()
  GetQuestionnairesPRISM: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_PRISM),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_PRISM + ' Effect - get questionnaires for patient')),
    map((action: GetQuestionnairesPRISM) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesPRISM(payload, 'PRISM')
        .map((prismArray: QuestionnairePRISMResult[]) => {
          return new GetQuestionnairesPRISMSuccess({
            resultsPRISM: prismArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesPRISMFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesPRISMSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_PRISM_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('prism') !== null) {
        localStorage.removeItem('prism');
      }
      localStorage.setItem('prism', JSON.stringify(data.payload.resultsPRISM));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesPRISMFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_PRISM_FAILURE)
  );

  @Effect()
  GetQuestionnairesPSQI: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_PSQI),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_PSQI + ' Effect - get questionnaires for patient')),
    map((action: GetQuestionnairesPSQI) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesPSQI(payload, 'PSQI')
        .map((psqiArray: QuestionnairePSQIResult[]) => {
          return new GetQuestionnairesPSQISuccess({
            resultsPSQI: psqiArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesPSQIFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesPSQISuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_PSQI_SUCCESS),
    tap((data) => {

      if (localStorage.getItem('psqi') !== null) {
        localStorage.removeItem('psqi');
      }
      localStorage.setItem('psqi', JSON.stringify(data.payload.resultsPSQI));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesPSQIFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_PSQI_FAILURE)
  );


  @Effect()
  GetQuestionnairesSIBDQ: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_SIBDQ),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_SIBDQ + ' Effect - get questionnaires SIBDQ for patient')),
    map((action: GetQuestionnairesSIBDQ) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesSIBDQ(payload, 'SIBDQ')
        .map((sibdqArray: QuestionnaireSIBDQResult[]) => {
          return new GetQuestionnairesSIBDQSuccess({
            resultsSIBDQ: sibdqArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesSIBDQFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesSIBDQSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_SIBDQ_SUCCESS),
    tap((data) => {

      if (localStorage.getItem('sibdq') !== null) {
        localStorage.removeItem('sibdq');
      }
      localStorage.setItem('sibdq', JSON.stringify(data.payload.resultsSIBDQ));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesSIBDQFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_SIBDQ_FAILURE)
  );

  @Effect()
  GetQuestionnairesIBDQ: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_IBDQ),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_IBDQ + ' Effect - get questionnaires IBDQ for patient')),
    map((action: GetQuestionnairesIBDQ) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesIBDQ(payload, 'IBDQ')
        .map((ibdqArray: QuestionnaireIBDQResult[]) => {
          return new GetQuestionnairesIBDQSuccess({
            resultsIBDQ: ibdqArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesIBDQFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesIBDQSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_IBDQ_SUCCESS),
    tap((data) => {

      if (localStorage.getItem('ibdq') !== null) {
        localStorage.removeItem('ibdq');
      }
      localStorage.setItem('ibdq', JSON.stringify(data.payload.resultsIBDQ));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesIBDQFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_IBDQ_FAILURE)
  );


  @Effect()
  GetQuestionnairesLARS: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_LARS),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_LARS + ' Effect - get questionnaires LARS for patient')),
    map((action: GetQuestionnairesLARS) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesLARS(payload, 'LARS')
        .map((larsArray: QuestionnaireLARSResult[]) => {
          return new GetQuestionnairesLARSSuccess({
            resultsLARS: larsArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesLARSFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesLARSSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_LARS_SUCCESS),
    tap((data) => {

      if (localStorage.getItem('lars') !== null) {
        localStorage.removeItem('lars');
      }
      localStorage.setItem('lars', JSON.stringify(data.payload.resultsLARS));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesLARSFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_LARS_FAILURE)
  );

  @Effect()
  GetQuestionnairesDataConsent: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_DATA_CONSENT),
    map((action: GetQuestionnairesDataConsent) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesDataConsent(payload, 'DATA-CONSENT')
        .map((dataConsentArray: QuestionnaireDataConsentResult[]) => {
          return new GetQuestionnairesDataConsentSuccess({
            resultsDataConsent: dataConsentArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesDataConsentFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesDataConsentSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_DATA_CONSENT_SUCCESS),
    tap((data) => {

      if (localStorage.getItem('data-consent') !== null) {
        localStorage.removeItem('data-consent');
      }
      localStorage.setItem('data-consent', JSON.stringify(data.payload.resultsDataConsent));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesDataConsentFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_DATA_CONSENT_FAILURE)
  );



  @Effect()
  GetQuestionnairesTSQM: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_TSQM),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_TSQM + ' Effect - get questionnaires TSQM for patient')),
    map((action: GetQuestionnairesTSQM) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesTSQM(payload, 'TSQM')
        .map((tsqmArray: QuestionnaireTSQMResult[]) => {
          return new GetQuestionnairesTSQMSuccess({
            resultsTSQM: tsqmArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesTSQMFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesTSQMSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_TSQM_SUCCESS),
    tap((data) => {

      if (localStorage.getItem('tsqm') !== null) {
        localStorage.removeItem('tsqm');
      }
      localStorage.setItem('tsqm', JSON.stringify(data.payload.resultsTSQM));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesTSQMFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_TSQM_FAILURE)
  );

  @Effect()
  GetQuestionnairesWPAI: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_WPAI),
    // tap( () => console.log(DoctorActionTypes.GET_QUESTIONNAIRES_WPAI + ' Effect - get questionnaires WPAI for patient')),
    map((action: GetQuestionnairesWPAI) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getQuestionnairesWPAI(payload, 'WPAI')
        .map((wpaiArray: QuestionnaireWPAIResult[]) => {
          return new GetQuestionnairesWPAISuccess({
            resultsWPAI: wpaiArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesWPAIFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetQuestionnairesWPAISuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_WPAI_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('wpai') !== null) {
        localStorage.removeItem('wpai');
      }
      localStorage.setItem('wpai', JSON.stringify(data.payload.resultsWPAI));
    })
  );

  @Effect({ dispatch: false })
  GetQuestionnairesWPAIFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_QUESTIONNAIRES_WPAI_FAILURE)
  );

  @Effect()
  GetJobs: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_JOBS),
    // tap( () => console.log(DoctorActionTypes.GET_JOBS + ' Effect - get Jobs for patient')),
    map((action: GetJobs) => action.payload),
    switchMap((payload) => {
      return this.doctorService.getJobs(payload)
        .map((jobsArray: JobModel[]) => {
          return new GetJobsSuccess({
            jobs: jobsArray
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetQuestionnairesWPAIFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetJobsSuccess: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_JOBS_SUCCESS),
    tap((data) => {
      if (localStorage.getItem('jobs') !== null) {
        localStorage.removeItem('jobs');
      }
      localStorage.setItem('jobs', JSON.stringify(data.payload.jobs));
    })
  );

  @Effect({ dispatch: false })
  GetJobsFailure: Observable<any> = this.actions$.pipe(
    ofType(DoctorActionTypes.GET_JOBS_FAILURE)
  );

}
